import { useCallback, useMemo } from 'react';
import { useAuthStore } from '../store/auth.store';
import { canOpenPage, hasPermission } from '../lib/permissions';

// What the signed-in user may do. `can('sales.create')` is true when their role allows it.
export const usePermissions = () => {
  const user = useAuthStore((state) => state.user) as
    | { id?: string; role?: string | { name?: string }; permissions?: string[]; isAdministrator?: boolean }
    | null;

  const permissions = useMemo(() => user?.permissions ?? [], [user]);
  const role = typeof user?.role === 'string' ? user.role : user?.role?.name;

  const can = useCallback((permission: string) => hasPermission(permissions, permission), [permissions]);
  const canAny = useCallback((...needed: string[]) => needed.some((permission) => hasPermission(permissions, permission)), [permissions]);
  const canOpen = useCallback((path: string) => canOpenPage(permissions, path), [permissions]);

  return {
    permissions,
    role,
    userId: user?.id,
    // The role that holds everything
    isAdministrator: role === 'admin',
    can,
    canAny,
    canOpen,
  };
};
